import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Translation, TranslocoService } from '@ngneat/transloco';
import { ChartType } from 'chart.js';
//import { MultiDataSet, Label } from 'ng2-charts';

@Component({
  selector: 'rm-objectif-doughnut',
  templateUrl: './t_objectif-doughnut.component.html',
  styleUrls: ['./objectif-doughnut.component.less']
})
export class ObjectifDoughnutComponent implements OnInit {

  
  @Input('ratio') ratio:string;
  @Input('values') values: number[];

  @Input('animation') animation:boolean = true;
  @Input() showTitle:boolean = false;
  @Input() showLegend:boolean = false;

  showChart:boolean = false;
 
  theme = {
    color: [
      '#9B73CE',
      '#CE9B73',
      '#A7CE73',
      '#cccccc'
    ],
    lineStyle: {
      color: '#ffffff',
      type: 'dashed'
    }
  };

  options = {
    
    height: '200px',
    calculable: true,
    series: [
      {
        name: 'half semi',
        type: 'pie',
        radius:  ['40%', '70%'],
        avoidLabelOverlap: false,
        //roseType: 'area',
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
            label: {
                show: true,
                fontSize: '15',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data: [
          { value: 0, name: 'Non traité' },
          { value: 0, name: 'En cours' },
          { value: 0, name: 'Terminé' },
          { value: 0, name: 'Annulé' },
        ]
      }
    ]
  }


 translation:Map<string, Translation>


  constructor(private cdRef: ChangeDetectorRef,
              private translocoService: TranslocoService) { 
              }

  ngOnInit() {
    if(this.ratio) 
      this.values = this.ratio.split('-').map((s)=>{ return parseInt(s); });

    if(!this.values) console.error('neither values or ratio found');

    this.calculateData();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  calculateData()
  {
    this.showChart = false;

    this.options.series[0].data =  [
      { value: this.values[0], name: this.translocoService.translate('rm-objectif-h4-5') },
      { value: this.values[1], name: this.translocoService.translate('rm-objectif-h4-6') },
      { value: this.values[2], name: this.translocoService.translate('rm-objectif-h4-7') },
      { value: this.values[3], name: this.translocoService.translate('rm-objectif-h4-8') },
    ];

    setTimeout(()=>{
      this.showChart = true;
    },0);
  }

}
